import apiClient from "@/api/client";
import type {
  SimulationAttachment,
  SimulationComment,
} from "@/features/finances/types/simulation";

const base = (simId: string) => `/finances/order-simulations/${simId}`;

const multipart = { headers: { "Content-Type": "multipart/form-data" } };

export const simulationDiscussionApi = {
  // ── Komentarze ──
  listComments: (simId: string) =>
    apiClient
      .get<{ data: SimulationComment[] }>(`${base(simId)}/comments/`)
      .then((r) => r.data.data),

  addComment: (simId: string, content: string, mentionIds: string[] = []) =>
    apiClient
      .post<{ data: SimulationComment }>(`${base(simId)}/comments/`, {
        content,
        mention_ids: mentionIds,
      })
      .then((r) => r.data.data),

  deleteComment: (simId: string, commentId: string) =>
    apiClient.delete(`${base(simId)}/comments/${commentId}/`).then(() => undefined),

  uploadCommentImage: (simId: string, file: File): Promise<string> => {
    const form = new FormData();
    form.append("file", file);
    return apiClient
      .post<{ data: { url: string } }>(`${base(simId)}/comments/upload-image/`, form, multipart)
      .then((r) => r.data.data.url);
  },

  uploadCommentAttachment: (simId: string, commentId: string, file: File) => {
    const form = new FormData();
    form.append("file", file);
    return apiClient
      .post<{ data: SimulationAttachment }>(
        `${base(simId)}/comments/${commentId}/attachments/`,
        form,
        multipart,
      )
      .then((r) => r.data.data);
  },

  // ── Załączniki symulacji ──
  listAttachments: (simId: string) =>
    apiClient
      .get<{ data: SimulationAttachment[] }>(`${base(simId)}/attachments/`)
      .then((r) => r.data.data),

  uploadAttachment: (simId: string, file: File) => {
    const form = new FormData();
    form.append("file", file);
    return apiClient
      .post<{ data: SimulationAttachment }>(`${base(simId)}/attachments/`, form, multipart)
      .then((r) => r.data.data);
  },

  deleteAttachment: (simId: string, attachmentId: string) =>
    apiClient.delete(`${base(simId)}/attachments/${attachmentId}/`).then(() => undefined),
};
